// @ts-nocheck
// // @ts-nocheck
// import Select from 'react-select';
// import Form from 'react-bootstrap/Form';
// import { useTranslation } from 'react-i18next';
// import { useDispatch } from 'react-redux';
// import { useFormik } from 'formik';
// import { formOrganization } from '../../ValidationForm/validationSchema';
// import { getOrganizations, insertOrganization } from '@store/HR/Organizations/organizationSlice';
// import useLookupOrgType from '@hooks/Lookups/use-Lookup-OrgType';
// import useLookupOrgClass from '@hooks/Lookups/use-Lookup-OrgClass';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import useGetLocations from '@hooks/HRSetting/use-get-locations';
// import SwalAlert from '@components/Shared/Alert/SwalAlert';
// import useGetOrganizations from '@hooks/HR/use-get-organizations';
// import useGetGlLedgersList from '@hooks/Finance/useGetGlLedgersList';

// const Add = props => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useDispatch();
//   const { OperatingUnitOptions, loading, error } = useGetOrganizations();
//   const { ORG_TYPE } = useLookupOrgType();
//   const { dataORGCLASS } = useLookupOrgClass();
//   const { Locations } = useGetLocations();

//   const formik = useFormik({
//     initialValues: {
//       // ID: "",
//       name2: '',
//       name: '',
//       locationId: '',
//       externalFlag: false,
//       dateFrom: '',
//       description: '',
//       // accountId: '',
//       operatingUnitId: '',
//       type: props.type ?? '',
//       organizationInformation: props.type === '150' ? 'HR_ORG' : '',
//       InternalOrExternal: '', // ليس للبوست
//       //
//       commercialRegistrationNumber: '',
//       vatNumber: ''
//     },

//     validationSchema: formOrganization(t),

//     onSubmit: values => {
//       if (values.type === '30') {
//         SwalAlert({
//           icon: 'info',
//           text: 'يرجى التواصل مع الدعم الفني لإتمام عملية إضافة شركة جديدة.'
//         });
//         formik.setSubmitting(false);
//         return;
//       }

//       dispatch(
//         insertOrganization({
//           businessGroupId: null,
//           locationId: values.locationId,
//           dateFrom: values.dateFrom,
//           name: values.name,
//           name2: values.name2,
//           externalFlag: values.InternalOrExternal === 'External' ? true : false,
//           description: values.description,
//           type: values.type,
//           organizationInformation: values.organizationInformation,
//           dateTo: null,
//           integrationField: '',
//           // accountId: values.accountId || null,
//           commercialRegistrationNumber: values.commercialRegistrationNumber,
//           vatNumber: values.vatNumber,
//           operatingUnitId: values.operatingUnitId || null
//         })
//       )
//         .unwrap()
//         .then(() => {
//           CustomAlert({ action: 'Add' });
//           document.getElementById('closeModal')?.click();
//           formik.resetForm();
//           dispatch(getOrganizations());
//         })
//         .catch(error => {
//           CustomAlert({ action: 'Error' });
//         })
//         .finally(() => formik.setSubmitting(false));
//     }
//   });

//   // handel multiSelect to this data ship (value1,value2,value3,value4)
//   const handleMultiSelectChange = selectedOptions => {
//     const formattedOptions = selectedOptions?.map(option => option.value).join(',');
//     formik.setFieldValue('organizationInformation', formattedOptions);
//   };

//   return (
//     <Form onSubmit={formik.handleSubmit}>
//       <div className='row'>
//         <div className='col-xl-6'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('LocalName')}</label>
//             <Form.Control
//               className='form-control'
//               type='text'
//               autoComplete='off'
//               name='name2'
//               onChange={formik.handleChange}
//               value={formik.values.name2}
//               isInvalid={formik.touched.name2 && formik.errors.name2}
//             />
//             <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
//           </div>
//         </div>

//         <div className='col-xl-6'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('GlobalName')}</label>
//             <Form.Control
//               className='form-control'
//               type='text'
//               autoComplete='off'
//               name='name'
//               onChange={formik.handleChange}
//               value={formik.values.name}
//               isInvalid={formik.touched.name && formik.errors.name}
//             />
//             <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
//           </div>
//         </div>
//         <div className='col-xl-6'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('location')}</label>
//             <Form.Select
//               className='form-select'
//               name='locationId'
//               onChange={formik.handleChange}
//               value={formik.values.locationId}
//               isInvalid={formik.touched.locationId && formik.errors.locationId}
//             >
//               <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//               {Locations?.map((item, idx) => (
//                 <option key={++idx} value={item.id}>
//                   {i18n.language === 'ar' ? item.name2 : item.name}
//                 </option>
//               ))}
//             </Form.Select>
//             <Form.Control.Feedback type='invalid'>{formik.errors.locationId}</Form.Control.Feedback>
//           </div>
//         </div>

//         <div className='col-xl-6'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('InternalOrExternal')}</label>
//             <Form.Select
//               className='form-select'
//               name='InternalOrExternal'
//               onChange={formik.handleChange}
//               value={formik.values.InternalOrExternal}
//               isInvalid={formik.touched.InternalOrExternal && formik.errors.InternalOrExternal}
//             >
//               <option key={1} value=''>
//                 {i18n.language === 'ar' ? 'إختر' : 'Choose'}
//               </option>
//               <option key={2} value='Internal'>
//                 {i18n.language === 'ar' ? 'داخلي' : 'Internal'}
//               </option>
//               <option key={3} value='External'>
//                 {i18n.language === 'ar' ? 'خارجي' : 'External'}
//               </option>
//             </Form.Select>
//             <Form.Control.Feedback type='invalid'>{formik.errors.InternalOrExternal}</Form.Control.Feedback>
//           </div>
//         </div>
//       </div>

//       <div className='row'>
//         {!props.type && (
//           <div className='col-xl-6'>
//             <div className='form-group mb-3'>
//               <label className='form-label'>{t('Type')}</label>
//               <Form.Select
//                 disabled={props.type !== undefined}
//                 className='form-select'
//                 name='type'
//                 onChange={formik.handleChange}
//                 value={formik.values.type}
//                 isInvalid={formik.touched.type && formik.errors.type}
//               >
//                 <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                 {ORG_TYPE?.map(item =>
//                   item.list?.map(list => (
//                     <option key={list.lookupCode} value={list.lookupCode}>
//                       {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                     </option>
//                   ))
//                 )}
//               </Form.Select>
//               <Form.Control.Feedback type='invalid'>{formik.errors.type}</Form.Control.Feedback>
//             </div>
//           </div>
//         )}

//         <div className='col-xl-6'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('Start Date')}</label>
//             <Form.Control
//               type='date'
//               id='START_DATE'
//               className='form-control'
//               name='dateFrom'
//               onChange={formik.handleChange}
//               value={formik.values.dateFrom}
//               isInvalid={formik.touched.dateFrom && formik.errors.dateFrom}
//             />
//             <Form.Control.Feedback type='invalid'>{formik.errors.dateFrom}</Form.Control.Feedback>
//           </div>
//         </div>

//         <div className='col-xl-6'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('OperationUnit')}</label>
//             <Select
//               classNamePrefix='react-select'
//               // className="text-center"
//               // isLoading={loadingAccounts}
//               isSearchable={true}
//               isClearable
//               options={OperatingUnitOptions}
//               value={OperatingUnitOptions?.find(f => f.value === formik.values.operatingUnitId) || null}
//               onChange={option => formik.setFieldValue('operatingUnitId', option?.value)}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//             />
//           </div>
//         </div>

//         {props.type === undefined && (
//           <div className='col-lg-12  mb-3'>
//             <label className='form-label '>
//               {t('Classification')} <span className='text-danger'>*</span>
//             </label>
//             <Select
//               required
//               isMulti
//               options={dataORGCLASS}
//               classNamePrefix='react-select'
//               name='organizationInformation'
//               onChange={handleMultiSelectChange}
//               value={
//                 formik.values.organizationInformation
//                   ? formik.values.organizationInformation.split(',').map(value => ({
//                       value,
//                       label: dataORGCLASS.find(option => option.value === value)?.label || value
//                     }))
//                   : []
//               }
//             />
//           </div>
//         )}
//       </div>

//       <div className='my-3' />

//       <div className='text-center'>
//         <div className='d-flex justify-content-between gap-2'>
//           <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100'>
//             {formik.isSubmitting ? (
//               <div className='spinner-border spinner-border-sm me-2'></div>
//             ) : (
//               <i className='fas fa-save fa-lg fa-fw me-2'></i>
//             )}
//             {t('Add')}
//           </button>
//           <button type='button' className='btn btn-lg  btn-default mb-1 w-100' data-bs-dismiss='modal' id='closeModal'>
//             <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//           </button>
//         </div>
//       </div>
//     </Form>
//   );
// };

// export default Add;

// {
//   /* <div className='row'>
//         <div className='col-xl-6'>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('CommercialRegistrationNumber')}</label>
//             <Form.Control
//               className='form-control'
//               type='text'
//               autoComplete='off'
//               name='commercialRegistrationNumber'
//               onChange={formik.handleChange}
//               maxLength='10'
//               pattern='\d{10}'
//               value={formik.values.commercialRegistrationNumber}
//               isInvalid={formik.touched.commercialRegistrationNumber && formik.errors.commercialRegistrationNumber}
//             />
//             <Form.Control.Feedback type='invalid'>{formik.errors.commercialRegistrationNumber}</Form.Control.Feedback>
//           </div>
//         </div>
//         <div className='col-xl-6  '>
//           <div className='form-group mb-3'>
//             <label className='form-label'>{t('VatNumber')}</label>
//             <Form.Control
//               className='form-control'
//               type='text'
//               autoComplete='off'
//               name='vatNumber'
//               onChange={formik.handleChange}
//               maxLength='15'
//               pattern='\d{15}'
//               value={formik.values.vatNumber}
//               isInvalid={formik.touched.vatNumber && formik.errors.vatNumber}
//             />
//             <Form.Control.Feedback type='invalid'>{formik.errors.vatNumber}</Form.Control.Feedback>
//           </div>
//         </div>
//       </div> */
// }

import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { formOrganization } from '../../ValidationForm/validationSchema';
import { getOrganizations, insertOrganization } from '@store/HR/Organizations/organizationSlice';
import useLookupOrgType from '@hooks/Lookups/use-Lookup-OrgType';
import useLookupOrgClass from '@hooks/Lookups/use-Lookup-OrgClass';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import useGetLocations from '@hooks/HRSetting/use-get-locations';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import useGetPersons from '@hooks/HR/use-get-persons';

const Add = props => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { OperatingUnitOptions, loading, error } = useGetOrganizations();
  const { ORG_TYPE } = useLookupOrgType();
  const { dataORGCLASS } = useLookupOrgClass();
  const { Locations } = useGetLocations();

  const { dataEmployees } = useGetPersons();

  const formik = useFormik({
    initialValues: {
      name2: '',
      name: '',
      locationId: '',
      externalFlag: false,
      dateFrom: '',
      dateTo: '',
      description: '',
      operatingUnitId: '',
      type: props.type ?? '',
      organizationInformation: props.type === '150' ? 'HR_ORG' : '',
      InternalOrExternal: '',
      code: '',
      manegerId: ''
    },

    validationSchema: formOrganization(t),

    onSubmit: values => {
      if (values.type === '30') {
        SwalAlert({
          icon: 'info',
          text: 'يرجى التواصل مع الدعم الفني لإتمام عملية إضافة شركة جديدة.'
        });
        formik.setSubmitting(false);
        return;
      }

      dispatch(
        insertOrganization({
          locationId: values.locationId,
          dateFrom: values.dateFrom,
          dateTo: values.dateTo || null,
          name: values.name,
          name2: values.name2,
          externalFlag: values.InternalOrExternal === 'External' ? true : false,
          description: values.description,
          type: values.type,
          organizationInformation: values.organizationInformation,
          operatingUnitId: values.operatingUnitId || null,
          code: values.code,
          manegerId: values.manegerId || null
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Add' });
          document.getElementById('closeModal')?.click();
          formik.resetForm();
          dispatch(getOrganizations());
        })
        .catch(error => {
          CustomAlert({
            action: 'Error',
            text: error.message || 'حدث خطأ أثناء الإضافة'
          });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  // handel multiSelect to this data ship (value1,value2,value3,value4)
  const handleMultiSelectChange = selectedOptions => {
    const formattedOptions = selectedOptions?.map(option => option.value).join(',');
    formik.setFieldValue('organizationInformation', formattedOptions);
  };

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className='row'>
        {/* الصف الأول: الحقول الأساسية */}
        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>
              {t('LocalName')} <span className='text-danger'>*</span>
            </label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='name2'
              onChange={formik.handleChange}
              value={formik.values.name2}
              isInvalid={formik.touched.name2 && formik.errors.name2}
              placeholder={i18n.language === 'ar' ? 'أدخل الاسم المحلي' : 'Enter local name'}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
          </div>
        </div>

        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>
              {t('GlobalName')} <span className='text-danger'>*</span>
            </label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='name'
              onChange={formik.handleChange}
              value={formik.values.name}
              isInvalid={formik.touched.name && formik.errors.name}
              placeholder={i18n.language === 'ar' ? 'أدخل الاسم العالمي' : 'Enter global name'}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
          </div>
        </div>

        {/* الصف الثاني: الحقول الإضافية */}
        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>
              {t('Code')} <span className='text-danger'>*</span>
            </label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='code'
              onChange={formik.handleChange}
              value={formik.values.code}
              isInvalid={formik.touched.code && formik.errors.code}
              placeholder={i18n.language === 'ar' ? 'أدخل الكود' : 'Enter code'}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.code}</Form.Control.Feedback>
          </div>
        </div>

        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>
              {t('location')} <span className='text-danger'>*</span>
            </label>
            <Form.Select
              className='form-select'
              name='locationId'
              onChange={formik.handleChange}
              value={formik.values.locationId}
              isInvalid={formik.touched.locationId && formik.errors.locationId}
            >
              <option value=''>{i18n.language === 'ar' ? 'إختر الموقع' : 'Choose location'}</option>
              {Locations?.map((item, idx) => (
                <option key={item.id} value={item.id}>
                  {i18n.language === 'ar' ? item.name2 : item.name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type='invalid'>{formik.errors.locationId}</Form.Control.Feedback>
          </div>
        </div>

        {/* الصف الثالث: التصنيف والتواريخ */}
        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>
              {t('InternalOrExternal')} <span className='text-danger'>*</span>
            </label>
            <Form.Select
              className='form-select'
              name='InternalOrExternal'
              onChange={formik.handleChange}
              value={formik.values.InternalOrExternal}
              isInvalid={formik.touched.InternalOrExternal && formik.errors.InternalOrExternal}
            >
              <option value=''>{i18n.language === 'ar' ? 'إختر النوع' : 'Choose type'}</option>
              <option value='Internal'>{i18n.language === 'ar' ? 'داخلي' : 'Internal'}</option>
              <option value='External'>{i18n.language === 'ar' ? 'خارجي' : 'External'}</option>
            </Form.Select>
            <Form.Control.Feedback type='invalid'>{formik.errors.InternalOrExternal}</Form.Control.Feedback>
          </div>
        </div>

        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('المدير / المسؤول')}</label>

            <Select
              classNamePrefix='react-select'
              isSearchable={true}
              isClearable
              options={dataEmployees}
              value={dataEmployees?.find(f => f.value === formik.values.manegerId) || null}
              onChange={option => formik.setFieldValue('manegerId', option === null ? null : option?.value)}
              placeholder={i18n.language === 'ar' ? 'إختر المدير' : 'Choose manager'}
              // isLoading={loading}
            />
          </div>
        </div>

        {/* الصف الرابع: التواريخ */}
        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>
              {t('Start Date')} <span className='text-danger'>*</span>
            </label>
            <Form.Control
              type='date'
              className='form-control'
              name='dateFrom'
              onChange={formik.handleChange}
              value={formik.values.dateFrom}
              isInvalid={formik.touched.dateFrom && formik.errors.dateFrom}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.dateFrom}</Form.Control.Feedback>
          </div>
        </div>

        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('End Date')}</label>
            <Form.Control
              type='date'
              className='form-control'
              name='dateTo'
              onChange={formik.handleChange}
              value={formik.values.dateTo}
              min={formik.values.dateFrom}
            />
          </div>
        </div>

        {/* الصف الخامس: الوصف */}
        {/* <div className='col-12'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('Description')}</label>
            <Form.Control
              as='textarea'
              rows={3}
              className='form-control'
              name='description'
              onChange={formik.handleChange}
              value={formik.values.description}
              placeholder={i18n.language === 'ar' ? 'أدخل وصف المؤسسة' : 'Enter organization description'}
            />
          </div>
        </div> */}

        {/* الصف السادس: الحقول المشروطة */}
        {!props.type && (
          <div className='col-xl-6'>
            <div className='form-group mb-3'>
              <label className='form-label'>
                {t('Type')} <span className='text-danger'>*</span>
              </label>
              <Form.Select
                className='form-select'
                name='type'
                onChange={formik.handleChange}
                value={formik.values.type}
                isInvalid={formik.touched.type && formik.errors.type}
              >
                <option value=''>{i18n.language === 'ar' ? 'إختر النوع' : 'Choose type'}</option>
                {ORG_TYPE?.map(item =>
                  item.list?.map(list => (
                    <option key={list.lookupCode} value={list.lookupCode}>
                      {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                    </option>
                  ))
                )}
              </Form.Select>
              <Form.Control.Feedback type='invalid'>{formik.errors.type}</Form.Control.Feedback>
            </div>
          </div>
        )}

        <div className='col-xl-6'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('OperationUnit')}</label>
            <Select
              classNamePrefix='react-select'
              isSearchable={true}
              isClearable
              options={OperatingUnitOptions}
              value={OperatingUnitOptions?.find(f => f.value === formik.values.operatingUnitId) || null}
              onChange={option => formik.setFieldValue('operatingUnitId', option?.value)}
              placeholder={i18n.language === 'ar' ? 'إختر وحدة التشغيل' : 'Choose operating unit'}
              isLoading={loading}
            />
          </div>
        </div>

        {props.type === undefined && (
          <div className='col-12 mb-3'>
            <label className='form-label'>
              {t('Classification')} <span className='text-danger'>*</span>
            </label>
            <Select
              // required
              isMulti
              options={dataORGCLASS}
              classNamePrefix='react-select'
              name='organizationInformation'
              onChange={handleMultiSelectChange}
              value={
                formik.values.organizationInformation
                  ? formik.values.organizationInformation.split(',').map(value => ({
                      value,
                      label: dataORGCLASS.find(option => option.value === value)?.label || value
                    }))
                  : []
              }
              placeholder={i18n.language === 'ar' ? 'إختر التصنيفات' : 'Choose classifications'}
            />
          </div>
        )}
      </div>

      <div className='my-3' />

      <div className='text-center'>
        <div className='d-flex justify-content-between gap-2'>
          <button
            disabled={formik.isSubmitting || !formik.isValid}
            type='submit'
            className='btn btn-lg btn-theme mb-1 w-100'
          >
            {formik.isSubmitting ? (
              <>
                <div className='spinner-border spinner-border-sm me-2'></div>
                {t('Adding...')}
              </>
            ) : (
              <>
                <i className='fas fa-save fa-lg fa-fw me-2'></i>
                {t('Add')}
              </>
            )}
          </button>
          <button
            type='button'
            className='btn btn-lg btn-default mb-1 w-100'
            data-bs-dismiss='modal'
            id='closeModal'
            onClick={() => formik.resetForm()}
          >
            <i className='fa fa-power-off fa-fw me-1'></i>
            {t('Cancel')}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default Add;
